import React, {useCallback, useMemo, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {
    dashboardsEntities,
    dashboardsSelected,
} from '../redux/quicksightUrl/selectors';
import {
    getQuicksightEmbeddedUrlRequest,
    setIdDashboardSelected,
    resetDateExpired,
} from '../redux/quicksightUrl/actions';
import {dashboardsLoadingSelector} from '../redux/quicksightUrl/selectors';
import {selectordashboardConfIds} from '../redux/dashboardConfiguration/selectors';

import Dashboard from './Dashboard';

const DashboardsContainer = ({
    startDate,
    endDate,
    componentsMapper,
    children,
}) => {
    const dashboardItems = useSelector(selectordashboardConfIds);
    const dashboardsEntitiesLoaded = useSelector(dashboardsEntities);
    const idDashboardsSelected = useSelector(dashboardsSelected);
    const loading = useSelector(dashboardsLoadingSelector);
    const dispatch = useDispatch();

    const firstDash = useMemo(
        () => dashboardItems && dashboardItems[0] && dashboardItems[0].idDash,
        [dashboardItems],
    );

    const setIdDashSel = useCallback(
        (idDash) => {
            if (!loading) {
                dispatch(setIdDashboardSelected({idDash}));
                if (
                    !dashboardsEntitiesLoaded[idDash] || dashboardsEntitiesLoaded[idDash].dateExpired < new Date()
                ) {
                    const conf = dashboardItems.find((elem) => elem.idDash === idDash);
                    dispatch(
                        getQuicksightEmbeddedUrlRequest({
                            idDash,
                            extraProperties: conf.properties || {},
                        }),
                    );
                }
            }

            return;
        },
        [dashboardItems, dashboardsEntitiesLoaded, dispatch, loading],
    );

    useEffect(() => {
        return () => {
            dispatch(resetDateExpired());
        };
    }, [dispatch]);
    resetDateExpired;

    const setIdDashSelHandler = useCallback(
        (idDash) => (e) => {
            !!e && e.preventDefault();
            setIdDashSel(idDash);
            return;
        },
        [setIdDashSel],
    );

    useEffect(() => {
        if (!idDashboardsSelected && firstDash) {
            setIdDashSel(firstDash);
        }
    }, [firstDash, setIdDashSel, idDashboardsSelected]);

    return (
        <>
            {dashboardItems && !!dashboardItems.length && (
                <div className="dashboards-container">
                    <div className="dashboards-header">
                        <div className="button-container">
                            {dashboardItems.map(
                                (dash, index) =>
                                    dash.idDash && (
                                        <button
                                            onClick={setIdDashSelHandler(dash.idDash)}
                                            key={dash.idDash}
                                            className={
                                                idDashboardsSelected === dash.idDash ?
                                                    'button-dash__selected' :
                                                    'button-dash__unselected'
                                            }
                                        > {dash.name}
                                        </button>
                                    ),
                            )}
                        </div>
            ``
                        {children}
                    </div>
                    <div className="quicksight-view">
                        {dashboardItems.map(
                            (dash) =>
                                dash &&
                !!dashboardsEntitiesLoaded[dash.idDash] && (
                                    <div
                                        key={dash.idDash}
                                        className={
                                            idDashboardsSelected === dash.idDash ?
                                                'offscreen-show' :
                                                'offscreen'
                                        }
                                    >
                                        <Dashboard
                                            dashboard={dashboardsEntitiesLoaded[dash.idDash]}
                                            startDate={startDate}
                                            endDate={endDate}
                                            selected={true}
                                            componentsMapper={componentsMapper}
                                        />
                                    </div>
                                ),
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default DashboardsContainer;
